<template>
  <div v-role="'func'">
    <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading"
      v-show="isLoading"></v-progress-linear>

    <div>

      <div class="grey lighten-5 ">
        <v-row>
          <v-col class="text-center" cols="12"><v-btn x-large fab dark color="primary" @click="dialog = true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
        </v-row>

      </div>

      <v-data-table :headers="headers" :items="profediscinas" :sort-desc="true" class="elevation-1" :search="search">
        <template v-slot:top>
          <v-toolbar flat color="white">

            <v-toolbar-title class="hidden-sm-and-down">
              Associar Professor a Turma

            </v-toolbar-title>

            <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

            <!--  search  -->
            <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
              {{ $store.state.textMessage }}
            </div>

            <div class="flex-grow-1"></div>

            <!--   <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
         end  search  -->

            <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
            <v-btn v-if="search" @click="initprofdisc(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} </span>

                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                            {{ $store.state.textMessage }}
                          </div>

                        </v-col>
                        <v-col v-if="false" cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.idFuncionario" label="cod"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="5">
                          <!--  <v-autocomplete
                        v-model="model"
                        :items="items"
                        :loading="isLoading"
                        :search-input.sync="search"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        item-text="name"
                        item-value="symbol"
                        label="Search for a coin..."
                        solo
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title>
                              Search for your favorite
                              <strong>Cryptocurrency</strong>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                          <v-chip
                            v-bind="attr"
                            :input-value="selected"
                            color="blue-grey"
                            class="white--text"
                            v-on="on"
                          >
                            <v-icon left>mdi-coin</v-icon>
                            <span v-text="item.name"></span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar
                            color="indigo"
                            class="headline font-weight-light white--text"
                          >
                            {{ item.name.charAt(0) }}
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.symbol"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-coin</v-icon>
                          </v-list-item-action>
                        </template>
                      </v-autocomplete>-->
                          <v-overflow-btn v-model="funcionario" :items="professores" label="Funcionário" editable
                            item-value="nome" item-text="nome" @keyup="Pesquisar()" @change="SelecionaFuncionario()">
                          </v-overflow-btn>

                        </v-col>

                        <v-col md="1">

                          <v-btn style="margin-top:20px;" v-if="editedItem.professor === 0"
                            @click="initialize(searchInDb)" text icon color="green">
                            <v-icon>cached</v-icon>
                          </v-btn>

                        </v-col>

                        <v-col cols="12" sm="12" md="6">

                          <v-combobox v-model="editedItem.curso" item-value="idCurso" item-text="descricao"
                            @change="loadTurmaComb" @click="loadTurmaComb" :items="cursos" chips
                            label="Curso"></v-combobox>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">

                          <v-combobox id="turma" v-model="editedItem.turma" item-value="pkturma"
                            item-text="turmadescricao" @change="loadDiscpilanComb" @click="loadDiscpilanComb"
                            :items="turmasFiltered" chips label="Turma"></v-combobox>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">

                          <v-combobox id="turma" v-model="editedItem.iddisciplina" item-value="iddisciplina"
                            item-text="descricao" :items="disciplinasFiltered" chips label="Disciplina"></v-combobox>

                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn v-if="!replace" color="blue darken-1" :disabled="!(formValid)
                    " text @click="save">Save</v-btn>

                  <v-btn v-if="replace" color=" darken-1" :disabled="!(formValid)
                    " text @click="save(true)">Substituir O professor</v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <v-icon small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>
          no data
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    replace: false,
    disciplinas: [],
    disciplinasFiltered: [],
    professordiscijaexiste: [],
    isLoading: false,
    items: [],
    model: null,
    search: null,
    text: '',
    Funcionario_selected: null,
    funcionario: '',
    flag_curso: '',
    formValid: true,
    isLoading: false,
    turmasAll: [],
    turmasFiltered: [],
    search: '',
    cursos: [],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Lecciona', value: 'descricao' },
      { text: 'Turma & Sala', value: 'turma' },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Ano Lectivo', value: 'anolectivo' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      idfuncionario: null,
      iddisciplina: 0,
      idpessoa: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''

    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Atribuir Disciplina ao Professor' : 'Editar'
    }

  },

  watch: {

    dialog(val) {
      val || this.close()
    },

    model(val) {
      if (val != null) this.tab = 0
      else this.tab = null
    },
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0) return

      this.isLoading = true

      // Lazily load input items
      fetch('https://api.coingecko.com/api/v3/coins/list')
        .then(res => res.clone().json())
        .then(res => {
          this.items = res
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }

  },

  created() {
    // check if classe has been selected otherwise send back to painel to select
    this.iniprofessores()
    // this.initprofdisc();
    this.initializeCursos()
    this.initializeturmasAll()
    this.initializedisciplinas()
  },

  methods: {

    async initprofdisc(search) {
      try {
        this.isLoading = true
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    SelecionaFuncionario() {
      this.Funcionario_selected = this.professores.filter(p => p.nome === this.funcionario)
    },

    async iniprofessores(search) {
      try {
        this.isLoading = true
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios
          .get('/professorFindAll/' + payload)
          .then(res => res.data)
        console.log(this.professores)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeCursos() {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializedisciplinas() {
      try {
        this.isLoading = true
        this.disciplinas = await axios
          .get('/disciplinaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadDiscpilanComb(turma) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.disciplinasFiltered = this.disciplinas.filter(t => t.idCurso === turma.idCurso && t.anoacademico === turma.idAno_Academico)
      this.$nextTick(() => { this.editedItem.iddisciplina = undefined })
    },

    loadTurmaComb(curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    async initializeturmasAll() {
      //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem(item) {
      this.editedIndex = this.profediscinas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.profediscinas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.profediscinas.splice(index, 1)
    },

    close() {
      this.replace = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save(replace) {
      this.professordiscijaexiste = this.profediscinas.filter(
        p => p.iddisciplina === this.editedItem.iddisciplina.iddisciplina && p.turma === this.editedItem.turma.turmadescricao
      ) // if the id is not there then check for BI in collection before create new record if BI is in the collection. the entry already exist, if not insertOne

      if (!this.professordiscijaexiste.length > 0 || this.editedItem.idProfessorDisciTurma > 0 || replace === true) {
        this.saveprof(replace)
      } else {
        this.replace = true
        this.$store.dispatch('textMessage', {
          msg: this.professordiscijaexiste[0].nome + ' é o professor que  lecciona  ' + this.editedItem.iddisciplina.descricao.toUpperCase() + ' na turma  ' + this.editedItem.turma.turmadescricao,
          classMessage: 'msgError',
          timeout: 7000
        })
      }
    },

    Pesquisar() {
      console.log(this.funcionario)
    },

    async ObterIdFuncionario(valor) {
      try {
        this.editedItem.idfuncionario = await axios
          .get('/ObterIdFuncionario/' + valor)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      if (this.editedItem.idfuncionario != null) { this.ObterIdPessoa(this.editedItem.idfuncionario) }
    },

    async ObterIdPessoa(valor) {
      try {
        this.editedItem.idpessoa = await axios
          .get('/ObterIdPessoa/' + valor.idFuncionario)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    Actualizar(replace) {
      if (this.professordiscijaexiste.length) {
        let indice = this.profediscinas.indexOf(this.professordiscijaexiste[0])
        this.profediscinas.splice(indice, 1)
      }
    },

    async saveprof(replace) {
      const ls = require('local-storage')

      if (this.professordiscijaexiste.length) {
        var params = {
          idProfessorDisciTurma: (this.professordiscijaexiste.length) ? this.professordiscijaexiste[0].idProfessordisciturma : 0,
          idTurma: this.editedItem.turma.idTurma,
          iddisciplina: this.editedItem.iddisciplina.iddisciplina,
          idProfessor: this.Funcionario_selected.toString().split('-')[0],
          fkTurma: this.editedItem.turma.pkTurma,
          desciplinaDescricao: this.editedItem.iddisciplina.descricao,
          idpessoa: this.Funcionario_selected.idPessoa

        }
      } else {
        try {
          var params =
          {
            idProfessorDisciTurma: 0,
            idTurma: this.editedItem.turma.idTurma,
            iddisciplina: this.editedItem.iddisciplina.iddisciplina,
            idProfessor: this.Funcionario_selected[0].idProfessor.toString().split('-')[0],
            fkTurma: this.editedItem.turma.pkTurma,
            desciplinaDescricao: this.editedItem.iddisciplina.descricao,
            idpessoa: this.Funcionario_selected[0].idPessoa
          }
        } catch (error) {
          console.log('---------------------------------------------------------' + error)
        }
      }

      console.log(params)

      try {
        let cor_mensagem = 'msgError'
        let msg = await axios
          .post('/professordisciInsertOrUpdate', params)
          .then(res => res.data)
        // this.text = msg[1].insertId

        // Verificação da mensagem retornada pelo server
        if (msg.length) {
          let erro = msg[0]
          this.text = 'Ocorreu um erro ao tentar efectuar a operação.\n' + erro[0].Message
          cor_mensagem = 'msgError'
        } else {
          this.text = 'Operação efectuada com sucesso.'
          cor_mensagem = 'msgSucess'
          this.Actualizar(replace)
          // Adiciona os dados na coleção
          let coll = {
            nome: this.editedItem.professor.toString().split('-')[1],
            descricao: this.editedItem.iddisciplina.descricao,
            turma: this.editedItem.turma.turmadescricao,
            periodo: this.editedItem.turma.periodo,
            curso: this.editedItem.turma.curso,
            anolectivo: this.editedItem.turma.anoLectivo
          }

          this.profediscinas.unshift(coll)
          this.close()
        }
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: cor_mensagem,
          timeout: 4000
        })
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      }
    }
  }
}
</script>
